import React from 'react'
import {useHistory} from "react-router-dom";

// Audio
import IntroSound from '../../audio/intro.wav';

// Material UI Components
import { makeStyles, Fade, Box, Icon, Typography, Zoom } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    Box: {
        cursor: 'pointer',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textDecoration: 'none',
    },
    Icon: {
        fontSize: theme.typography.h1.fontSize,
        color: theme.palette.primary.main
    },
}));

export default function Start( {volume} ) {
    const Style = useStyles();
    const history = useHistory();
    const [startFadeAnimation, setStartFadeAnimation] = React.useState(true);
    const [typoAnimation, setTypoAnimation] = React.useState(false);

    // Audio
    const introSound = new Audio(IntroSound);
    
    // Volume
    introSound.volume = volume;
    
    // This method will fade out the content and will switch to the selection "page"
    const handleClick = (event) => {
        event.preventDefault();
        
        introSound.play();

        setStartFadeAnimation(!startFadeAnimation);

        setTimeout(() => {
            history.push("/game");
        }, 2000);
    } 

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setTypoAnimation(true);
        }, 5000);

        return () => clearTimeout(timeout); 
    }, [setTypoAnimation]);
    
    return (
        <Fade in={startFadeAnimation} timeout={2000}>
            <Box className={Style.Box} p={2} onClick={(event) => handleClick(event)}> 
                <Typography variant="button" style={{visibility: "hidden"}}>Click anywhere to continue</Typography>
                <Zoom in timeout={4000}>
                    <Icon className={`${Style.Icon} fas fa-bullseye logo`} />
                </Zoom>
                <Fade in={typoAnimation} timeout={2000} >
                    <Typography variant="button" color="textPrimary">Click anywhere to continue</Typography>
                </Fade>
            </Box>
        </Fade>
    )
}